import React, { Component } from 'react';
import {createSelector} from "reselect";
import {connect} from "react-redux";
import Skeleton from '@material-ui/lab/Skeleton';
import { Main } from '../../layout';
import { DocumentTitle } from '../../../helpers';
import { Container, Accordion, Button } from 'react-bootstrap';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';


class Careers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rules: [],
            loading: false,
            activeKey: 1
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({loading: true});
        itemService.rules("GET").then(data => {
            this.setState({loading: false, rules: data});
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    render() {
        const { activeKey, loading, rules } = this.state;

        return (<Main>
            <DocumentTitle title={`Rules`}/>
            <section className="faq mt-5">
                <Container>
                    <div className="rule">
                        <Accordion className="panel-group">
                            {loading ? <>
                                {[1,2,3].map((item) =>
                                    <div className="w-100 mb-3" key={`loading-${item}`}>
                                            <Skeleton variant="rect" width={'100%'} height={50} />
                                    </div>
                                )}
                            </> : <> 
                            {rules && rules.map((rule, index) =>
                                <div className="panel panel-default" key={`rule${index}`}>
                                    <Accordion.Toggle className="panel-heading w-100 text-left p-0 border-0" as={Button} variant="link" eventKey={rule.id} onClick={() => {
                                        if (activeKey === rule.id) {
                                            this.setState({activeKey: null});
                                        } else {
                                            this.setState({activeKey: rule.id});
                                        }
                                    }}>
                                        <h4 className="panel-title">
                                            <a role="button" rel="noopener noreferrer">
                                                {activeKey === rule.id ? <i className="more-less fa fa-minus"></i> : <i className="more-less fa fa-plus"></i>}
                                                {index + 1}. {rule.name}  
                                            </a>
                                        </h4>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse className="panel-collapse" eventKey={rule.id}>
                                        <div className="panel-body py-3">
                                            {rule.content}
                                        </div>
                                    </Accordion.Collapse>
                                </div>
                            )}
                            {(rules && rules.length === 0) && <div className="py-3 text-white">Rules not found</div>}
                            </>}
                        </Accordion>
                    </div>
                </Container>
            </section>  
        </Main>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(Careers);